



















import Vue from "vue";
import Navbar from "./components/Navbar.vue";
import Snackbar from "./components/Snackbar.vue";
import * as store from "./plugins/store";

const CookieLaw = require("vue-cookie-law");
// @ts-ignore
import {GChart} from 'vue-google-charts'

Vue.component("GChart", GChart);

export default {
    components: {Navbar, Snackbar, CookieLaw},
    data: () => ({
        map1Data: [
            ['Country', 'Popularity'],
            ['Germany', 200],
            ['United States', 300],
            ['Brazil', 400],
            ['Canada', 500],
            ['France', 600],
            ['RU', 700]
        ],
        map1Options: {
            backgroundColor: {fill: 'transparent'},
            colorAxis: {colors: ['yellow', 'red']},
            mapsApiKey: 'AIzaSyDdRmGhfE2hBf_DODRLnOH2Ww68B94h7bE'
        }
    })
};
